<template>
  <div class="card-container channel">
    <el-card>
      <common-el-form
        :model="formModel"
        :showButton="false"
        :submitData="submitData"
        @success="onSuccess"
        ref="formModel"
        submitBtnText="查询"
        :preservation="false"
      >
        <div style="display: flex">
          <div>
            <el-form-item label="汇总类型">
              <el-select
                style="width: 200px; margin-left: -20px"
                clearable
                v-model="formModel.collectionType"
              >
                <el-option
                  v-for="item in collectionType"
                  :key="item.id"
                  :label="item.name"
                  :value="item.id"
                >
                </el-option>
              </el-select>
            </el-form-item>
          </div>
          <div style="margin-left: 50px; width: 250px">
            <el-form-item label="方向">
              <el-select
                style="width: 200px; margin-left: -50px"
                clearable
                v-model="formModel.directionType"
              >
                <el-option
                  v-for="item in directionType"
                  :key="item.id"
                  :label="item.name"
                  :value="item.id"
                >
                </el-option>
              </el-select>
            </el-form-item>
          </div>
          <div style="margin-left: 50px">
            <el-form-item label="下发日期">
              <el-date-picker
                style="margin-left: -20px"
                v-model="formModel.sendDate"
                type="daterange"
                range-separator="至"
                :clearable="true"
                value-format="yyyy-MM-dd"
                start-placeholder="开始日期"
                end-placeholder="结束日期"
              >
              </el-date-picker>
            </el-form-item>
          </div>
          <el-button
            style="margin-left: 50px"
            type="warning"
            @click="handleExport"
            class="button-size"
            >导出</el-button
          >
        </div>
      </common-el-form>
    </el-card>
  </div>
</template>

<script>
import CommonElForm from "components/common/CommonElForm";
import ElFormItem from "element-ui/packages/form/src/form-item";
import PosService from "service/PosService";
import StatisticsService from "service/StatisticsService";
import { encrypt, urlEncode, objKeySort } from "common/js/common-utils";
import { loadMixin, dialogMixin, validatorsMixin } from "mixin";
import { mapGetters } from "vuex";

export default {
  name: "posgather",
  components: {
    ElFormItem,
    CommonElForm,
  },
  data() {
    return {
      formModel: {
        collectionType: "",
        directionType: "",
        sendDate: "",
      },
      tableData: [],
      collectionType: [],
      directionType: [
        {
          id: "1",
          name: "入库",
        },
        {
          id: "2",
          name: "出库",
        },
      ],
      submitService: PosService.posgatherList,
      params: {},
      //   page: {},
      //   isPage: false,
    };
  },
  inject: ["reload"],
  mixins: [loadMixin, dialogMixin, validatorsMixin],
  mounted() {
    this.load();
  },
  computed: {
    submitData() {
      if (this.formModel.sendDate == null || this.formModel.sendDate == "") {
        this.formModel.sendDate = [];
      }
      this.params = {
        collectionType: this.formModel.collectionType,
        directionType: this.formModel.directionType,
      };
      if (this.formModel.sendDate.length) {
        this.params.startTime = this.formModel.sendDate[0];
        this.params.endTime = this.formModel.sendDate[1];
      }
      return this.params;
    },
    ...mapGetters(["serverType", "tatId", "userId", "userInfo"]),
  },
  methods: {
    load() {
      this.formModel = {
        collectionType: "",
        directionType: "",
        sendDate: "",
      };
      //   this.page = this.$refs.commonTable.page;
      //   this.getList();
      this.getcollectionType();
    },
    // getPage() {
    //   this.isPage = true;
    //   this.getList();
    // },
    // getList() {
    //   this.doLoad(
    //     this.submitService,
    //     this.submitData,
    //     (res) => {
    //       this.doCheck(res, (res) => {
    //         this.onSuccess(res);
    //         this.isPage = false;
    //       });
    //     },
    //     "信息获取失败"
    //   );
    // },
    onSuccess(res) {
      this.doCheck(res, (res) => {
        const result = res.contents;
        // this.tableData = result.rows;
        // this.page.currentPage = result.current;
        // this.page.total = result.total;
        // this.page.pageSize = result.size;
      });
    },
    getcollectionType() {
      //兑换类型
      this.doLoad(
        PosService.poscollectionType,
        "",
        (res) => {
          this.doCheck(res, (res) => {
            this.collectionType = res.contents;
          });
        },
        "信息获取失败"
      );
    },
    handleExport() {
      if (!this.formModel.directionType) {
        this.showWarming("请选择'方向'");
        return;
      }
      StatisticsService.exportExcel(
        this.submitData,
        "collectMachines",
        "8885",
        "/machines/t-machines/"
      );
    },
  },
};
</script>

<style scoped>
.box-card {
  margin-bottom: 30px;
}
</style>



// WEBPACK FOOTER //
// src/view/page/PosImplement/PosGather.vue